export default {
  type: 'legal',
  aliases: ['legal'],
  path: 'Legal/LegalTemplate.vue',
  slices: []
};